// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

/*
Most environment values can be overwritten by values from /assets/environment.json.
However, production and hmr MUST be in an application environment file (such as this file)
since they are accessed in main.ts and processed before the environment service kicks in.
 */

export const environment = {
    production: false,
    useMocks: false,
    hmr: false,
    jwtLoginBaseApiUrl: `https://auth-dev.parcelpro.com/api`,
    v3BaseApiUrl: `https://apiint-dev.parcelpro.com/api`,
    authBaseUrl: `https://auth-dev.parcelpro.com`,
    digitalWalletBaseApiUrl: `https://digitalwallet-eagle.parcelpro.com/api/v1`,
    signalRHubBaseUrl: `https://notifications-dev.parcelpro.com`,
    reCAPTCHAv2SiteKey: '6Lf4sSArAAAAAHybMh5JO88N3svJbsut2RUrLYQJ',
    reCAPTCHAv3SiteKey: '6LdcsSArAAAAAGRuMnOSFVzo1WyqZJMppuQ9LCge',
    sites: {
        en: 'localhost',
        de: 'upscapitalde.com',
        'en-gb': 'upscapitaluk.com',
        fr: 'upscapitalfr.com',
        it: 'upscapitalit.com',
    },
    shouldUseGlobalExceptionHandler: true,
    refreshTokenConfig: {
        offsetInMinutes: 5,
    },
    feature: {
        debugTools: false,
        upsAccessPoint: true,
        deliveryDefense: true,
        glia: true,
        frit: true,
        trackShipments: true,
        refreshToken: true,
        addressUpload: true,
        disableEditShipFromLocationEU: true,
        reCAPTCHA: true,
        orderManagement: {
            core: true,
            bulkActions: true,
        },
        reportShipmentsBulkUpload: true,
        claims: {
            dashboard: true,
            faq: true,
            fileClaim: true,
            messenger: true,
        },
        behaviorTrackingAnalytics: {
            enabled: false,
            defaultProvider: 'adobe',
            adobe: {
                enabled: true,
                useLaunch: true,
                script: {
                    url: 'https://assets.adobedtm.com/parcelpro/AppMeasurement.js',
                    launchUrl: 'https://assets.adobedtm.com/parcelpro-launch.js',
                },
                noscript: {
                    url: 'https://assets.adobedtm.com/parcelpro/ns.html',
                },
            },
            gtm: {
                enabled: false,
                id: 'GTM-N2QZ78B',
                script: {
                    url: 'https://www.googletagmanager.com/gtm.js',
                },
                noscript: {
                    url: 'https://www.googletagmanager.com/ns.html',
                },
            },
            posthog: {
                enabled: false,
                apiKey: 'phc_JfggACRTY7xSNg4lpmv6G3OH28KvWctapPBzPOUljlB',
                apiHost: 'https://us.i.posthog.com',
            },
        },
        sessionIdle: {
            enabled: true,
            idleWarningTimeInSeconds: 18 * 60,
            idleTimeoutTimeInSeconds: 20 * 60,
        },
    },

    //#region start app state config
    // Unless it's a forced refresh, an app state refresh should be allowed only if it's older than x min after the last retrieval.
    appStateExpirationInMinutes: 1,
    //#endregion end app state config

    // This can be different per environment.
    claimSupportEmail: 'customerservice@parcelpro.com',
};
